module.exports = __webpack_public_path__ + "img/W7026-mod.164bd3e1.jpg";